import userPreferencesItem from '../defaults/userPreferencesItem.json';

export function initPreferences(user, appConfig) {
  return new Promise(async (resolve, reject) => {
    let response;
    let id;

    response = await window.api.searchPortal(
      `type:"Web Mapping Application" typekeywords:"IRWIN.Observer.Preferences" owner:${
        user.username
      }`
    );

    if (!response.results.length) {
      response = await createPrefsItem();
      id = response.id;
    } else {
      id = response.results[0].id;
    }

    const preferences = await window.api.getPortalItemData(id);
    resolve({ id, preferences });
  });
}

export function updatePreferences(id, preferences) {
  window.api.updatePortalItem(id, JSON.stringify(preferences));
}

//
// PRIVATE METHODS
//

function createPrefsItem() {
  return new Promise((resolve, reject) => {
    window.api.addPortalItem(userPreferencesItem).then(resolve, reject);
  });
}



// WEBPACK FOOTER //
// ./src/utils/userPreferences.js